<template>
  <div class="markup">
    <p class="markup__title">Вы уверены что хотите установить единую наценку на весь каталог?</p>
    <div class="markup__wrapper">
      <span>Наценка:</span>
      <masked-input
        v-model="totalMarkup"
        @keydown.native="checkValue"
        :mask="mask" />
    </div>
    <BaseBtn
      @btnClick="updateTotal"
      :text="'Применить'" />
  </div>
</template>

<script>
import MaskedInput from 'vue-masked-input';
import { mapActions } from "vuex";

export default {
  name: 'PopupTotalMarkup',

  components: {
    MaskedInput,
    BaseBtn: () => import('@/components/base/BaseBtn'),
  },

  data: () => ({
    totalMarkup: '',
    mask: '111%'
  }),

  methods: {
    ...mapActions('account', [
      'saveTotal',
      'pullMarkups',
    ]),

    checkValue(e) {
      const mask = '111%';
      const mask_minus = '-111%';

      if (e.key === 'Backspace' && this.mask === mask_minus && e.target.selectionStart === 0) {
        this.mask = mask;
      }

      if (e.key === '-') {
        this.mask = mask_minus;
      }
    },

    updateTotal() {
      this.togglePreload();
      this.saveTotal(this.totalMarkup.replace('_', ''))
        .then(res => {
          if (res.errorMessage) {
            this.$danger(res.errorMessage);
            this.togglePreload();
          } else {
            this.pullMarkups()
              .finally(() => {
                this.togglePreload();
              });
          }
        })
        .catch(error => {
          this.togglePreload();
          this.$danger('Ошибка при обновлении скидки')
        })
        .finally(() => {
          this.updatePopup(null, null)
        })
    }
  },
};
</script>

<style scoped lang="scss">
.markup {
  width: 100vw;
  max-width: 482px;
  background: #FFFFFF;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.3);
  padding: 50px 10px 28px 10px;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 41px;

    span {
      font-size: 16px;
      color: #000;
      margin-right: 13px;
    }
  }

  &__title {
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #000;
    max-width: 355px;
    margin: 0 auto 17px;
  }
}
</style>
